
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { NotificationItemProps } from ".";
import { loading, update } from "store/notification";
import { AppMessage } from "components";

interface ApiNotificationUpdateInputProps extends NotificationItemProps {
}

type ApiNotificationUpdateOutputProps = OutputBaseProps<{ item: NotificationItemProps; }, ApiNotificationUpdateInputProps>

export const apiNotificationUpdate = async (data: ApiNotificationUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiNotificationUpdateOutputProps>("/api/notification/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};